
import React from 'react';
import { TGeographyData } from '../types/EmpresaTypes';

type TDropdownFieldProps ={
  label: string;
  name: string;
  value: string;
  options: TGeographyData[];
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  error?: string;
  required?: boolean;
}

export const DropdownField: React.FC<TDropdownFieldProps> = ({ label, name, value, options, onChange, error, required }) => (

  <div className="form-group">
    <label htmlFor={name}>{label}{required && '*'}</label>
    <select
      id={name}
      name={name}
      value={value}
      onChange={onChange}
      className={`form-control ${error ? 'is-invalid' : ''}`}
    >
      <option value="">Seleccione una opción</option>
      {options.map(opt => <option key={opt.key} value={name === "ciudadDireccion" ? opt.value : opt.text}>{opt.text}</option>)}
    </select>
    
    {error && (
     <div className="invalid-feedback">
      {error}
      </div>
    )}
  </div>
);
